import { FC, useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { NakedButton, UsePopoverDialogResponse, Text } from '@frontend/design-system';
import { buttonStyles } from './share-org-asset-trigger.styles';

type PopoverDialogProps = Pick<
  UsePopoverDialogResponse<HTMLButtonElement, false, HTMLDialogElement>,
  'getTriggerProps'
>;

interface ShareOrgAssetTriggerProps {
  selectedLocationIds: string[];
  getPopoverDialogTriggerProps: PopoverDialogProps['getTriggerProps'];
  trackingId?: string;
}

export const ShareOrgAssetTrigger: FC<ShareOrgAssetTriggerProps> = ({
  selectedLocationIds,
  getPopoverDialogTriggerProps,
  trackingId,
}) => {
  const { t } = useTranslation('forms');

  const getTextContent = useCallback(
    (count: number) => {
      if (count === 0) {
        return t('Select Locations');
      }

      if (count === 1) {
        return t('1 Location');
      }

      return t('{{count}} Locations', { count });
    },
    [t]
  );

  return (
    <NakedButton {...getPopoverDialogTriggerProps()} css={buttonStyles} trackingId={trackingId}>
      <Icon name='location-small' />
      <Text as='span'>{getTextContent(selectedLocationIds.length)}</Text>
      <Icon name='caret-down-tiny' />
    </NakedButton>
  );
};
